import React, { FC, useState } from 'react';
import { useHistory } from 'react-router';
import { Box } from '@chakra-ui/react';

import { useAlert, useApi } from '@app/hooks';

import { AgreementFormInstance } from './types';
import AgreementForm from './form';
import { Paper } from '../common/paper';

type EquipmentsCreateProps = {};

const AgreementCreate: FC<EquipmentsCreateProps> = () => {
  const history = useHistory();
  const api = useApi();
  const { error, success } = useAlert();
  const [loading, setLoading] = useState<boolean>(true);

  const onFormSubmit = async (instance: Partial<AgreementFormInstance>) => {
    setLoading(true);
    const { data: response } = await api.agreements.postAgreement({
      type_id: instance.type?.id || null,
      outlet_id: instance.outlet?.id || null,
      distributor_id: instance.distributor?.id || null,
      number: instance.number || '',
      name: instance.name || '',
      date_open: instance.date_open || null,
      date_close: instance.date_close || null,
      comment: instance.comment || '',
      filename: instance.files?.[0]?.file.name || '',
      content: instance.files?.[0]?.data || '',
    });

    const { code, message, data } = response;

    if (code !== 200) {
      error(message);
      setLoading(false);
      return;
    }

    await api.agreements.updateAgreementEquips({
      agreement_id: data.id,
      equips:
        instance.equips
          ?.filter((item) => item.id)
          .map((item) => item.id?.toString() || '') || [],
    });
    setLoading(false);
    success('Соглашение создано');
    history.push('/agreements/');    
  };

  const onFormCancel = () => {
    history.push('/agreements/');
  };

  return (
    <Box paddingX={{ xs: 0, sm: 2, md: 10, lg: 14, xl: 20 }}>
      <Paper>
        <Box paddingX={4} paddingY={6}>
          <AgreementForm
            loading={loading}
            instance={{}}
            onSubmit={onFormSubmit}
            onCancel={onFormCancel}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default AgreementCreate;
